import Plugin from '../Plugin'


export default class Waddle extends Plugin {

    constructor(network) {
        super(network)
        this.events = {
            'get_waddles': this.getWaddles,
            'join_waddle': this.joinWaddle,
            'update_waddle': this.updateWaddle
        }
    }

    getWaddles(args) {
        this.world.room.setWaddles(args.waddles)
    }

    joinWaddle(args) {
        // Update local waddle state with the player's seat before showing UI
        // This prevents race condition where UI shows empty slots
        if (this.world.room.waddles) {
            const waddleData = this.world.room.waddles[args.waddle]
            
            if (waddleData && Array.isArray(waddleData)) {
                const username = this.world.client.penguin.displayUsername || this.world.client.penguin.username
                waddleData[args.seat] = username
            }
        }
        
        this.interface.main.waddle.show(args.waddle, args.seat, args.game)
    }

    updateWaddle(args) {
        if (this.world.room.isReady) {
            this.world.room.updateWaddle(args.waddle, args.seat, args.username)
        }
    }

}
